/* Official LINE clicks only. Reuses the app's gtag without changing tag or consent settings. */
(() => {
  'use strict';
  const root = document.documentElement;
  if (window.Shopify?.designMode || root.dataset.hgtLineTrackingInitialized) return;
  root.dataset.hgtLineTrackingInitialized = 'true';

  const seen = new WeakSet();
  const waitMs = 150;
  const isOfficialLine = (href) => {
    try {
      const url = new URL(href, document.baseURI);
      if (url.protocol !== 'https:' || url.username || url.password || url.port) return false;
      const path = decodeURIComponent(url.pathname).replace(/\/$/, '');
      return (url.hostname === 'lin.ee' && ['/1kzUgMK', '/DfjBLLK'].includes(path)) ||
        (url.hostname === 'line.me' && path === '/R/ti/p/@524xuybu');
    } catch (_) { return false; }
  };

  const onClick = (event) => {
    if (!event.isTrusted || event.defaultPrevented || seen.has(event)) return;
    if (!((event.type === 'click' && event.button === 0) ||
          (event.type === 'auxclick' && event.button === 1))) return;
    // Resolve the actual anchor, including clicks on its image/text and dynamic content.
    const link = event.composedPath().find((node) => node instanceof HTMLAnchorElement && node.hasAttribute('href'));
    if (!link || link.hasAttribute('download') || !isOfficialLine(link.href)) return;
    if (typeof window.gtag !== 'function') return;
    seen.add(event);

    const target = (link.getAttribute('target') || document.querySelector('base[target]')?.getAttribute('target') || '_self').toLowerCase();
    const waitForTag = event.type === 'click' && event.cancelable && target === '_self' &&
      !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    const params = { send_to: 'AW-11001315175/h9jnCOyngvICEOf-6v0o' };
    let resume;
    if (waitForTag) {
      const destination = link.href;
      let navigated = false;
      let timer;
      resume = () => {
        if (navigated) return;
        navigated = true;
        clearTimeout(timer);
        window.location.assign(destination);
      };
      // Independent timeout also releases navigation if gtag is only a queue or throws.
      timer = setTimeout(resume, waitMs);
      event.preventDefault();
      params.event_callback = resume;
      params.event_timeout = waitMs;
    }
    try {
      window.gtag('event', 'conversion', params);
    } catch (_) {
      if (resume) resume();
    }
  };

  // Bubble at window so existing link handlers can cancel first. Never stop propagation.
  // Keyboard activation produces click; middle-click produces auxclick, not both here.
  window.addEventListener('click', onClick);
  window.addEventListener('auxclick', onClick);
})();
